/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { IService } from "../../../../interfaces/services";
import { useParams, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useEntityNavigation } from "@/hooks/useEntityNavigation";
import useMounted from "../../../../hooks/mounted";
import { createService, deleteService, listServices, showService, updateService } from "@/services/activities/serviciesService";
import { updateValue } from "@/utils/updateValue";
import { useEntityQueryParams } from "@/hooks/useEntityQueryParams";
import { useEntitySearch } from "@/hooks/useEntitySearch";
import {
  notifyDeleteResults,
  runDeleteBatch,
} from "@/utils/deleteResults";

const DEFAULT_DATA: IService = {
  id: '',
  name: '',
  description: '',
  idCoordinator: null,
  allowOnlyOneInProgress: false,
  allowUserToAdjustReceivable: false,
  enableProposalLimitForThirdParty: false,
  maxProposalPercentageForThirdParty: 0,
  allowedToExceedMaxProposal: [],
  activityRequiredFieldIds: [],
  activityHiddenFieldIds: []
};

export const useServices = ({ filter: filterInitial, disabledShowId, includes = [], disabledGetAll, defaultLimit, serviceId }:{
  disabledGetAll?: boolean;
  disabledShowId?: boolean;
  defaultLimit?: number;
  filter?: Record<string, any>,
  includes?: string[],
  serviceId?: string}) => {
  const { idService:id } = useParams();
  const localtion = useLocation();
  const [services, setServices] = useState<IService[]>([]);
  const [service, setService] = useState<IService>(DEFAULT_DATA);
  const { filter, handleFilter, sort, handleSort, page, setPage, limit, setLimit } =
    useEntityQueryParams({ filter: filterInitial, defaultLimit });
  const [totalItems, setTotalItems] = useState<number>(0);
  const [enableChangePositionMap, setEnableChangePositionMap] =useState<boolean>(false)
  const { goAdd, goEdit, goBack } = useEntityNavigation({ basePath: "/towermanagement/services" });

  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleService = (key: string, value: any, custom?: (v: any) => any) => {
    setService((curr: any) => {
      let newData = updateValue(curr, key, value);
      if (custom) newData = custom(newData);
      return { ...curr, ...newData };
    });
  };

  
  
  const getAll = ({ page = 1, limit }:  { page?: number;limit?: number}) => {
    setLoading(true);
    listServices({ includes: [...includes], filter,  page, limit, sort })
      .then(({ services: listServices, limit, currentPage, totalItems }) => {
        setServices(listServices);
        
        setLimit(Number(limit));
        setTotalItems(totalItems)
      })
      .finally(() => setLoading(false));
  };


  const search = useEntitySearch({ list: listServices, key: "services", includes, filter });

  const get = ({ id }: { id: string | number }) => {
    setLoading(true);
    showService({ id })
      .then(({ service: servicesShow }) => {
        setService(servicesShow);
      })
      .finally(() => setLoading(false));
  };

  const create = () => {
    setLoading(true);
    createService({ service })
      .then(({ service: serviceCreate }) => {
        toast.success(`Serviço criado com sucesso!`);
        goEdit(serviceCreate.id!);
      })
      .finally(() => setLoading(false));
  };

  const update = () => {
    setLoading(true);
    updateService({ id: service.id!, service })
      .then(({ service: serviceUpdate }) => {
        toast.success(`Serviço atualizado com sucesso!`);
        goEdit(serviceUpdate.id!);
      })
      .finally(() => setLoading(false));
  };


  useMounted(() => {
    getAll({page, limit})
  }, [page, limit, filter, sort])

  useEffect(() => {
    console.log(1)
    const isPage = localtion.pathname.includes('/towermanagement/services');
    const targetId = serviceId || id;
    
    if (targetId && (isPage || serviceId) && !disabledShowId) {
      if (targetId !== "new") get({ id: targetId });
      return;
    }
    if (!disabledGetAll) getAll({limit});
  }, [serviceId]);

  const deleteMany = async (ids: (string | number)[]) => {
    if (!ids?.length) return;
    setLoading(true);

    try {
      const results = await runDeleteBatch(ids, (entityId) =>
        deleteService({ id: entityId }),
      );

      notifyDeleteResults(results, {
        singular: "Serviço",
        plural: "serviços",
        gender: "m",
      });
    } catch {
      // erro sem resposta do servidor (rede/timeout): o interceptor já avisou
    } finally {
      setLoading(false);
      getAll({ page, limit });
    }
  };

  return {
    deleteMany,
    services,
    service,
    loading,
    setPage,
    setLimit,
    page,
    limit,
    goEdit,
    goBack,
    goAdd,
    handleService,
    create,
    id,
    update,
    enableChangePositionMap,
    setEnableChangePositionMap,
    totalItems,
    search,
    handleFilter,
    handleSort
  };
};
